export const ProductStockSubscriptionsEndpoint = {
  GET_PENDING_SUBSCRIPTIONS: '/api/admin/product/stock-subscriptions',
};
